import React, {useEffect, useState} from "react";
import {LegendItem} from ".";

export default function Legend({chart}) {
    const [state, setState] = useState({active: []});

    useEffect(() => {
        if (!chart) return;
        setState(state => ({
            ...state,
            active: chart.visibleDays
        }));

    }, [chart])


    function toggleVisibility(val) {
        if (chart.chart.isDatasetVisible(val)) {
            chart.hide(val)
            setState(state => ({...state, active: {...state.active, [val.toString()]: false}}))
        } else {
            chart.show(val)
            setState(state => ({...state, active: {...state.active, [val.toString()]: true}}))
        }
    }

    if (!chart) return ('');
    return (
        <ul className={'chartLegend'}>{chart.chart.data.datasets.map((x, i) => (
            <LegendItem dataset={x} active={state.active[i.toString()]} key={i} onClick={() => toggleVisibility(i)}/>))}
        </ul>)
}